import RouteError from '@/components/ui/route-error';
import { createFileRoute } from '@tanstack/react-router';
import DashboardRouteLayout from '@/app/components/dashboard-route-layout';
import DashboardPageShell from '@/app/components/dashboard-page-shell';
import { DICTIONARY } from '@/config/dictionary';
import { requireAuth } from '@/utils/require-auth-before-load';
import { queryClient } from '@/lib/query-client';
import PermissionsAdminTab from '@/features/admin-settings/components/permissions-admin-tab';
import { getPermissionsQueryOptions } from '@/features/admin-settings/api/rbac-api';

const d = DICTIONARY.adminSettingsPage.permissionsAdmin;

const PermissionsAdminPage = () => (
  <DashboardRouteLayout>
    <DashboardPageShell title={d.pageTitle} description={d.pageDescription}>
      <PermissionsAdminTab />
    </DashboardPageShell>
  </DashboardRouteLayout>
);

export const Route = createFileRoute('/admin-settings/permissions-admin')({
  beforeLoad: requireAuth,
  loader: async () => {
    await queryClient.prefetchQuery(getPermissionsQueryOptions());
    return null;
  },
  component: PermissionsAdminPage,
  errorComponent: RouteError,
});
